export const addSubTaskToMap = (parentTaskToSubtaskMap, subTask) => {
	if (subTask.parentTaskId) {
		const subTaskIds = parentTaskToSubtaskMap.get(subTask.parentTaskId) || [];
		if (!subTaskIds.includes(subTask.id)) {
			subTaskIds.push(subTask.id);
		}
		parentTaskToSubtaskMap.set(subTask.parentTaskId, subTaskIds);
	}
};

export const changeSubTaskDates = (component, parentTaskToSubtaskMap, taskItem) => {
	const subTaskIds = parentTaskToSubtaskMap.get(taskItem.groupId);
	if (subTaskIds) {
		// Find sub tasks that inherit their dates
		const subTaskItems = component.state.items.filter(item => subTaskIds.includes(item.groupId) && !!item?.data?.task?.startFrom);
		if (subTaskItems) {
			subTaskItems.forEach(subTaskItem => {
				// Used for drawing item
				subTaskItem.startDate = taskItem.startDate;
				subTaskItem.endDate = taskItem.endDate;
				// Used for item tooltip
				subTaskItem.data.task.startYear = taskItem.data.task.startYear;
				subTaskItem.data.task.startMonth = taskItem.data.task.startMonth;
				subTaskItem.data.task.startDay = taskItem.data.task.startDay;
				subTaskItem.data.task.endYear = taskItem.data.task.endYear;
				subTaskItem.data.task.endMonth = taskItem.data.task.endMonth;
				subTaskItem.data.task.endDay = taskItem.data.task.endDay;
				changeSubTaskDates(component, parentTaskToSubtaskMap, subTaskItem);
			});
		}
	}
};

export const insertTaskInGroupTree = (groupToTraverse, subTaskGroup) => {
	if (groupToTraverse.groups) {
		groupToTraverse.groups.forEach(group => {
			if (group?.data?.task?.id === subTaskGroup.data.task.parentTaskId) {
				group.data.expandable = true;
				subTaskGroup.addSubTaskLevel(group.data.subTaskLevel + 1);
				group.groups.push(subTaskGroup);
			} else {
				insertTaskInGroupTree(group, subTaskGroup);
			}
		});
	}
};

export const findTaskGroupInTree = (groupToTraverse, taskId) => {
	let result;
	for (let i = 0; i < groupToTraverse.groups.length; i++) {
		const group = groupToTraverse.groups[i];
		if (group?.data?.task?.id === taskId) {
			return group;
		}
		const innerResult = findTaskGroupInTree(group, taskId);
		if (innerResult) {
			result = innerResult;
		}
	}
	return result;
};

export const getSubTasks = (parentTaskToSubtaskMap, tasks, task, isInheritingDate) => {
	const subTaskIds = parentTaskToSubtaskMap.get(task.id);
	let subTasks;
	subTasks = subTaskIds ? tasks.filter(item => subTaskIds.includes(item.id)) : [];
	if (isInheritingDate) {
		subTasks = subTasks.filter(item => !!item.startFrom);
	}

	const result = [];
	subTasks.forEach(task => {
		result.push(...getSubTasks(parentTaskToSubtaskMap, tasks, task, isInheritingDate));
	});
	result.push(...subTasks);
	return result;
};

export const addDependenciesFromTasks = (tasks, dependencies) => {
	tasks.forEach(taskNode => {
		const task = taskNode.node;
		if (task.thisTaskDependsOn) {
			task.thisTaskDependsOn.edges.forEach(dep => {
				const thisTaskDependsOn = dep.node;

				const dependency = {
					completed: thisTaskDependsOn.completed,
					id: thisTaskDependsOn.id,
					taskIdDependsOnThis: task.id,
					thisDependsOnTaskId: thisTaskDependsOn.thisDependsOnTask.id,
					type: thisTaskDependsOn.type,
				};

				dependencies.push(dependency);
			});
		}
	});
};

export const getTopParentId = (taskMap, task) => {
	if (!task.parentTaskId) {
		return task.id;
	} else {
		return getTopParentId(taskMap, taskMap.get(task.parentTaskId));
	}
};

export const isTaskInHierarchy = (task, parentTaskToSubtaskMap) => {
	return !!(task && (task.parentTaskId || parentTaskToSubtaskMap.has(task.id)));
};
